export default {
    EMAIL: 'EMAIL',
    PIN: 'PIN',
    SMS: 'SMS',
    LINK: 'LINK'
};
